import React from 'react'
import { Plus } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { FIGMA_COLUMN_1, FIGMA_COLUMN_1_FOOTER_ORANGE, FIGMA_KANBAN_COLUMN } from './figmaKanbanTheme'
import { FigmaKanbanColumnShell } from './FigmaKanbanColumnShell'

interface FigmaKanbanColumnProps {
  count: number
  children: React.ReactNode
  setDroppableRef: (node: HTMLElement | null) => void
  isOver?: boolean
  onAddCandidates?: () => void
  onLaunchAIMatching?: () => void
  showAddButton?: boolean
}

/** First hiring step (order 1) — display label Candidats / Candidates. */
export function FigmaKanbanColumn({
  count,
  children,
  setDroppableRef,
  isOver = false,
  onAddCandidates,
  onLaunchAIMatching,
  showAddButton = false,
}: FigmaKanbanColumnProps) {
  const { t } = useTranslation()
  const displayTitle = t('kanban.figmaCandidatesColumn', 'Candidates')

  const headerActions =
    showAddButton && onAddCandidates ? (
      <button
        type="button"
        onClick={onAddCandidates}
        className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-white transition-opacity hover:opacity-90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#19A6A6]/40"
        style={{ backgroundColor: FIGMA_COLUMN_1.accent }}
        aria-label={t('kanban.addCandidates', 'Add candidates')}
        title={t('kanban.addCandidates', 'Add candidates')}
      >
        <Plus className="h-3.5 w-3.5" strokeWidth={2.5} />
      </button>
    ) : null

  const footer = onLaunchAIMatching ? (
    <button
      type="button"
      onClick={onLaunchAIMatching}
      className="flex w-full shrink-0 items-center justify-center px-4 py-3 font-['Montserrat',sans-serif] text-xs font-medium leading-[1.5] text-white transition-opacity hover:opacity-95 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#19A6A6]/40"
      style={{ backgroundColor: FIGMA_COLUMN_1_FOOTER_ORANGE }}
    >
      {t('offers.actions.aiMatching', 'Lancer le matching AI')}
    </button>
  ) : undefined

  return (
    <FigmaKanbanColumnShell
      title={displayTitle}
      count={count}
      theme={FIGMA_COLUMN_1}
      setDroppableRef={setDroppableRef}
      isOver={isOver}
      headerActions={headerActions}
      footer={footer}
    >
      {children}
    </FigmaKanbanColumnShell>
  )
}
